/**
 * Buyer Signup Steps
 */
const EMAIL_PASSWORD = 'email_password';
const COMPANY_INFO_STEP = 'company_info';
const ABOUT_YOU_STEP = 'basic_profile';
const PAYMENT_METHOD_STEP = 'payment_method';
const VERIFY_EMAIL_STEP = 'validate_email';
const COMPANY_PENDING_APPROVAL_STEP = 'pending_approval';
const ADMIN_APPROVAL_STEP = 'admin_approval';

export const BUYER_SIGNUP_STEPS = {
  EMAIL_PASSWORD,
  COMPANY_INFO_STEP,
  ABOUT_YOU_STEP,
  PAYMENT_METHOD_STEP,
  VERIFY_EMAIL_STEP,
  COMPANY_PENDING_APPROVAL_STEP,
  ADMIN_APPROVAL_STEP,
};

/**
 * Available buyer signup flows
 */
const BUYER_SIGNUP_WITH_PAYMENT_METHOD_FLOW = 'buyer_signup_with_payment_method_flow';
const BUYER_SIGNUP_WITH_PAYMENT_METHOD_FLOW_SSO = 'buyer_signup_with_payment_method_flow_sso';
const BUYER_SIGNUP_WITHOUT_PAYMENT_METHOD_FLOW = 'buyer_signup_without_payment_method_flow';
const BUYER_SIGNUP_WITHOUT_PAYMENT_METHOD_FLOW_SSO = 'buyer_signup_without_payment_method_flow_sso';

export const BUYER_SIGNUP_FLOWS = {
  BUYER_SIGNUP_WITH_PAYMENT_METHOD_FLOW,
  BUYER_SIGNUP_WITH_PAYMENT_METHOD_FLOW_SSO,
  BUYER_SIGNUP_WITHOUT_PAYMENT_METHOD_FLOW,
  BUYER_SIGNUP_WITHOUT_PAYMENT_METHOD_FLOW_SSO,
};
